export const IS_DEV = !process.env.REACT_APP_FAKE_NODE_ENV || process.env.REACT_APP_FAKE_NODE_ENV === 'development';

// console.log(process.env);

export default IS_DEV ? 'staging' : 'production';

export const NEEDS_PASSWORD = process.env.REACT_APP_NEEDS_PASSWORD === 'true';
